import { IShopLabel } from '~/src/api/content/shop/getShopItems';
import { IAction } from '~/src/store';

import { ESpeedBonusActions } from './constants';

interface IEquipmentProp {
    title: string,
    name?: string,
    type?: string,
    value: string,
    asIs?: 0 | 1 | number,
}

export type TPrice = {
    cost: number,
    duration: number,
}

export interface IPreparedRouter {
    id: number,
    category: string,
    categoryTitle: string,
    title: string,
    description: string,
    body: string,
    image: string,
    images: string[],
    labels: IShopLabel[],
    props: IEquipmentProp[],

    image_width?: number,
    image_height?: number,
    image_webp?: string,

    prices: TPrice[],
    selectedPrice: TPrice,

    quantity: number,
}

export const setRouters = (routers: IPreparedRouter[]): IAction<ESpeedBonusActions.setRouters, IPreparedRouter[]> => ({
    type: ESpeedBonusActions.setRouters,
    payload: routers,
});
